import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Tabs,
  Tab,
  Button,
  Stack,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import ReactJson from "react-json-view";
import { isValidJSON } from "../reviewComponents/reviewUtils";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Editor from 'react-simple-code-editor';
import Prism, { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism.css";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-handlebars";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-textmate";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import ace from "ace-builds/src-noconflict/ace";
import { getOtherFilter, setOtherFilter } from "../../../../common/utils/setOtherFilter";
import "ace-builds/src-noconflict/ext-searchbox";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


Prism.languages.custom = {
  'template-variable': {
    pattern: /{{[^{}]*}}/,
    greedy: true
  },
  'percent-variable': {
    pattern: /%[^%]*%/,
    greedy: true
  }
};
const copyToClipboard = (text) => {
  const tempInput = document.createElement("input");
  tempInput.value = text;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
};

const PromptText = ({
  output,
  isManage,
  promptText,
  setPromptText,
  prompt,
  jsonResponseSchemValue,
  setJsonResponseSchemaValue,
  jsonResponseSchema=false,
  systemPrompt,
  setSystemPrompt,
  // New props for expand/collapse
  expanded,
  setExpanded,
  ArrowBackIcon,
  ArrowForwardIcon,
  isNew
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const [selectedTab,setSelectedTab]=useState(1)
  const [code,setCode]=useState('')
  const [cursorPositions, setCursorPositions] = useState({
    1: { row: 0, column: 0 }, // User Prompt
    2: { row: 0, column: 0 }, // JSON Schema
    3: { row: 0, column: 0 }  // System Prompt
  });

  const [findOpenTabs, setFindOpenTabs] = useState(false);
  const theme = useTheme();
  const isJsonSchemaInvalid = useMemo(() => {
    if (!jsonResponseSchema || !jsonResponseSchemValue) return false;
    try {
      const parsed = JSON.parse(jsonResponseSchemValue);
      return !(parsed && typeof parsed === "object" && !Array.isArray(parsed));
    } catch (e) {
      return true;
    }
  }, [jsonResponseSchema, jsonResponseSchemValue]);

  useEffect(()=>{
    setCode(promptText)
  },[promptText])
  const handleCopy = () => {
    copyToClipboard(output);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  };
  const getOutput = (out) => {
    let text = JSON.parse(out);
    try {
      return text? isValidJSON(text)?JSON.parse(text) :text : out;
    }
    catch (ex) {
      return text;
    }
  }
  useEffect(()=>{
    // setSelectedTab(1)
    const selectedTab = getOtherFilter('promptTextTab', false);
  
    if(selectedTab){
      setSelectedTab(parseInt(selectedTab))
    }else{
      setSelectedTab(1)
    }
  },[prompt])
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setOtherFilter('promptTextTab', newValue, false);
  };
  
  const handleCursorChange = (selection) => {
    setCursorPositions(prev => ({
      ...prev,
      [selectedTab]: {
        row: selection.cursor.row,
        column: selection.cursor.column
      }
    }));
  };
const handleChangePromptText=(newValue)=>{
  setPromptText(newValue)
}
const handleChangeSystemPrompt=(newValue)=>{
  setSystemPrompt(newValue)
}

const handlePromptCopy=()=>{
  const text = `System Prompt: \n
${systemPrompt} \n\n\n
User Prompt: \n
${promptText} \n\n\n
JSON Schema: \n
  ${jsonResponseSchemValue}`;

  navigator.clipboard.writeText(text);
  setIsCopied(true);
  setTimeout(() => setIsCopied(false), 1000);
}
  const isManageText=()=>{  
    
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: "1px solid #888", pt: 0.5 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab sx={{textTransform:'none'}} value={3} label={"System Prompt"}/>
          <Tab sx={{textTransform:'none'}} value={1} label={"User Prompt"}/>
          <Tab sx={{textTransform:'none'}} value={2} label={"JSON Schema"} disabled={!jsonResponseSchema}/>
        </Tabs>
        <Stack direction="row" spacing={1} alignItems="center">
        { (
          <Tooltip title={"Copy All tabs content to clipboard"} disableInteractive arrow>
            <IconButton
              onClick={handlePromptCopy}
              size="small"
              // color="primary"
              disabled={!systemPrompt || !promptText || !jsonResponseSchemValue}
            >
              <FileCopyIcon fontSize="small" />
              {isCopied && (
                <Typography variant="caption" color="primary" sx={{ position: 'absolute', top: '-46px' }}>
                  Copied!
                </Typography>
              )}
            </IconButton>
          </Tooltip>)}
        {isManage && expanded !== undefined && setExpanded && (
          <Tooltip title={!expanded ? "Expand" : "Collapse"} disableInteractive arrow>
            <IconButton
              onClick={() => setExpanded((prev) => !prev)}
              size="small"
              color="primary"
            >
              {expanded && ArrowBackIcon ? <ArrowBackIcon /> : null}
              {!expanded && ArrowForwardIcon ? <ArrowForwardIcon /> : null}
            </IconButton>
          </Tooltip>
        )}
        </Stack>
      </Box>
    )
   
  }
const aceEditorData = useMemo(()=>{
  if(selectedTab===1){
    return {
      value: promptText ?? '',
      onChange: handleChangePromptText,
      mode: "handlebars",
      name:"prompt-text-editor",
      indentedSoftWrap: false,
      onCursorChange: handleCursorChange,
      
    }
  }else if(selectedTab===2){
    return {
      value: jsonResponseSchemValue ?? '',
      onChange: setJsonResponseSchemaValue,
      mode: "json",
      name:"json-schema-editor",
      indentedSoftWrap: true,
      onCursorChange: handleCursorChange,
     
    }
  }else if(selectedTab===3){
    return {
      value: systemPrompt ?? '',
      onChange: handleChangeSystemPrompt,
      mode: "handlebars",
      name:"system-prompt-editor",
      indentedSoftWrap: false,
      onCursorChange: handleCursorChange,
    }
  }
},[selectedTab, promptText, jsonResponseSchemValue, systemPrompt, cursorPositions])
  return isManage ? 
  (
    <>
    {isManageText()}
      {(selectedTab === 1 || selectedTab===2 || selectedTab===3)&&(isNew||prompt?.promptId) ?
      <Box mt={1} sx={{ position: 'relative' }}> 
      <AceEditor
        key={selectedTab}
        value={aceEditorData.value}
        onChange={aceEditorData.onChange}
        onCursorChange={aceEditorData.onCursorChange}
        cursorStart={cursorPositions?.[selectedTab]}
        onLoad={(editor) => {
          editor.moveCursorTo(cursorPositions?.[selectedTab]?.row ?? 0, cursorPositions?.[selectedTab]?.column ?? 0);

          if (findOpenTabs) {
            setTimeout(() => {
              editor.execCommand("find");
            }, 0);
          }

          editor.commands.addCommand({
            name: "customFind",
            bindKey: { win: "Ctrl-F", mac: "Command-F" },
            exec: function (editor) {
              setFindOpenTabs(true);
              editor.execCommand("find");
            }
          });

          
          editor.commands.addCommand({
            name: "closeSearch",
            bindKey: { win: "Escape", mac: "Escape" },
            exec: function (editor) {
              if (findOpenTabs) {
                setFindOpenTabs(false);
                editor.searchBox.hide();
              }
            }
          });

          const checkSearchBox = () => {
            if (editor.searchBox) {
              const isVisible = editor.searchBox.element && 
                               editor.searchBox.element.style.display !== 'none' && 
                               editor.searchBox.element.offsetParent !== null;
              
              if (!isVisible && findOpenTabs) {
                setFindOpenTabs(false);
              }
            }
          };

          const interval = setInterval(checkSearchBox, 100);
          
          editor.on('destroy', () => clearInterval(interval));
        }}
        focus={true}
        showGutter={false}
        name={aceEditorData.name}
        mode={aceEditorData.mode}
        theme={theme.palette.mode === 'dark' ? 'monokai' : 'textmate'}
        style={theme.palette.mode === 'dark' ? { backgroundColor: 'transparent' } : { backgroundColor: 'transparent' }}
        highlightActiveLine={false}
        wrapEnabled={true}
        showPrintMargin={false}
        // showPrintMargin={false}
        fontSize={16}
        lineHeight={20}
        width="100%"
        height="calc(100vh - 170px)"
        setOptions={{
          useWorker: false,
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          enableMobileMenu: false,
          showLineNumbers: false,

          useSoftTabs: true,
          tabSize: 2,
          wrap: 'free',
          wrapMethod:'text',
          indentedSoftWrap: aceEditorData.indentedSoftWrap,

        }}
        
      />
      {selectedTab === 2 && jsonResponseSchema && isJsonSchemaInvalid && (
        <Box sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.error.main}`,
          color: theme.palette.error.main,
          borderRadius: 1,
          p: '4px 8px',
          boxShadow: theme.shadows[2],
          zIndex: 2,
        }}>
          <Typography variant="caption" component="div">
            JSON schema must be a valid JSON object
          </Typography>
        </Box>
      )}
      </Box>:
     
         <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', padding:'80px 0'}}>
           <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Please select any prompt from the left side or add a new Prompt.
           </Typography>
         </Box>
      }
    </>
  ) : (
    <fieldset
     
      style={{
        border: '1px solid',
        borderColor: "rgba(0, 0, 0, 0.2)",
        borderRadius: '4px',
        padding: '16px',
        marginTop: 1,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        minHeight: 'calc(100vh - 200px)',
      }}
    >
      <legend >
        Output
      </legend>
      <div style={{ flex: 1, marginTop: "20px" }}>
        {isValidJSON(output) ? (
          <div>
            {output ? (
              <Tooltip title="Copy to clipboard">
                <IconButton
                  style={{ position: "absolute", top: 0, right: 0 }}
                  onClick={handleCopy}
                >
                  <FileCopyIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}
            <ReactJson
              style={{
                // marginTop: "20px",
                whiteSpace: "pre-wrap",
                // border: "1px solid #ccc",
                minHeight: '100px',
                overflow: 'auto',
                minHeight: 'calc(100vh - 232px)',
                maxHeight: "calc(100vh - 232px)"
              }}
              src={getOutput(output)}
              name={null}
              theme="rjv-default"
              collapsed={false}
              enableClipboard={false}
              displayDataTypes={false}
            />
          </div>
        ) : (
          <div>
            {output ? (
              <Tooltip title="Copy to clipboard">
                <IconButton
                  style={{ position: "absolute", top: 0, right: 0 }}
                  onClick={handleCopy}
                >
                  <FileCopyIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}
            {output}
          </div>
        )}
      </div>
    </fieldset>
  );
};

export default PromptText;
